// extracted by mini-css-extract-plugin
export default {"container":"ncmViewContainerList_container__7v7lH"};